/* BodenWerk Motion – Scroll-Reveals (IntersectionObserver, dependency-free).
   CSS-Gegenstücke in bw-theme.css (.bw-reveal / .bw-reveal-media / .bw-lightline).
   Regeln: above-fold sofort (Lade-Choreografie), bereits passierte Elemente sofort,
   prefers-reduced-motion: alles sofort sichtbar, keine Bewegung. */
(function () {
  'use strict';

  var all = function () {
    return document.querySelectorAll('.bw-reveal:not(.is-inview), .bw-reveal-media:not(.is-inview)');
  };

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    all().forEach(function (el) { el.classList.add('is-inview'); });
    return;
  }

  /* Stagger: Kinder eines [data-bw-stagger]-Containers laufen mit 90ms Versatz an. */
  var stagger = function () {
    document.querySelectorAll('[data-bw-stagger]').forEach(function (parent) {
      var i = 0;
      parent.querySelectorAll(':scope > .bw-reveal, :scope > * > .bw-reveal').forEach(function (child) {
        child.style.setProperty('--bw-d', (i * 0.09).toFixed(2) + 's');
        i += 1;
      });
    });
  };

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        /* isIntersecting: normal im Blick. top < 0: beim schnellen Scrollen
           bereits passiert – nie unsichtbar zurücklassen. */
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
  );

  var init = function () {
    stagger();
    var fold = window.innerHeight;
    all().forEach(function (el) {
      var top = el.getBoundingClientRect().top;
      if (top < fold) {
        /* Above-fold (inkl. Hero): sofort enthüllen – Stagger-Delays choreografieren den Einstieg. */
        el.classList.add('is-inview');
      } else {
        io.observe(el);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify-Theme-Editor lädt Sections dynamisch nach. */
  document.addEventListener('shopify:section:load', init);
})();
